module.exports = __webpack_public_path__ + "static/media/Futurebank.b7917f43.svg";